import { Injectable } from '@angular/core';
import { AmdocsAuthService } from 'amdocs-auth-package';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public promptEvent: any;
  public roleToken: string | undefined;
  public empId: string | undefined;
  public upn: string = '';

  constructor(private authService: AmdocsAuthService) { }

  private name = '';

  public setUserDetails(): void {
    const formattedToken: any = jwtDecode(this.authService.getToken());
    this.name = formattedToken.name ? formattedToken.name : '';
    this.empId = formattedToken.upn ? formattedToken.upn : '';
    this.upn = formattedToken.upn ? formattedToken.upn : '';
  }

  public getName(): string {
    return this.name;
  }

  public getFirstName(): string {
    return this.name.split(' ')[0];
  }
}
